import Service from "./Service";
const resource = "/news";

export default {
  async getAll() {
    const resp = await Service.get(`${resource}`);
    const data = resp.data;

    return data;
  },
  async getNews($lang, $posts_per_page = -1, $offset = 0) {
    const params = {
      posts_per_page: $posts_per_page,
      offset: $offset,
    };

    if ($lang) {
      params["lang"] = $lang;
    }

    const resp = await Service.get(`${resource}`, {
      params: params,
    });

    return resp.data;
  },
};
